import {Key, PrivateKey} from "openpgp";
import {EntityDto} from "../services/messages/EntityDto";
import {EnrichedPgpKey} from "./pgp/EnrichedPgpKey";
import {ContactAddress, extractFriendlyNamesFromEmailAddresses} from "../util/Formatters";
import {enrichPgpKey} from "../security/PgpKeyEnricher";

export const TemporaryKeyId = -1;

export interface PgpKey extends EntityDto {
    key: Key;
    isPrivate: boolean;
    keyHexId: string;
    enrichedKey?: EnrichedPgpKey;
}

export async function pgpKeyFromRawKey(key: Key, allKeys: PgpKey[]): Promise<PgpKey> {
    const pgpKey: PgpKey = {
        key,
        isPrivate: key.isPrivate(),
        keyHexId: getKeyHexId(key),
        Id: TemporaryKeyId,
    };
    pgpKey.enrichedKey = await enrichPgpKey(pgpKey, allKeys);
    return pgpKey;
}

export interface UnknownPgpKey {
    unknownKeyHexId: string;
}

export function getKeyUserIds(pgpKey: PgpKey): string[] {
    return pgpKey.key.getUserIDs();
}

export function getKeyFirstUserId(pgpKey: PgpKey | undefined): string | undefined {
    return pgpKey?.key.getUserIDs()?.[0];
}

export function getKeyContact(pgpKey: PgpKey | undefined): ContactAddress {
    return extractFriendlyNamesFromEmailAddresses(getKeyFirstUserId(pgpKey))[0];
}

export function getKeyHexId(key: Key): string;
export function getKeyHexId(key: Key | undefined): string| undefined;
export function getKeyHexId(key: Key | undefined): string | undefined {
    return key?.getKeyID().toHex();
}

export function getPgpPrivateKeys(pgpKeys: PgpKey[]) {
    return pgpKeys.map(k => k.key as PrivateKey);
}
